import React, { useCallback } from 'react'
import { SummaryEventRowBreakProps, SummaryEventRowProps } from '@sport1/news-styleguide/Types'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import SummaryEventRow from '@sport1/news-styleguide/SummaryEventRow'
import colorPattern from '@sport1/news-styleguide/colorPattern'
import getGoals from '@/components/LivetickerSummary/utils/getGoals'
import LivetickerSummaryButton from '@/components/LivetickerSummary/Button'
import { useTracking } from '@/utils/tracking/TrackingProvider'

export enum SummaryState {
    SMALL,
    BIG,
}

type Props = { matchEvents: SummaryEventRowProps[]; testID?: string }

const LivetickerSummary = ({ matchEvents, testID }: Props) => {
    const goals = React.useRef<(SummaryEventRowProps | SummaryEventRowBreakProps)[]>([])
    const [summary, setSummary] = React.useState<
        (SummaryEventRowProps | SummaryEventRowBreakProps)[]
    >([])
    const [summaryState, setSummaryState] = React.useState<SummaryState>(SummaryState.SMALL)
    const { trackInteraction } = useTracking()

    const toggleSummary = useCallback(() => {
        trackInteraction({
            interaction_category: 'liveticker',
            interaction_action: summaryState === SummaryState.BIG ? 'close' : 'open',
            interaction_label: 'telegram',
        })
        if (summaryState === SummaryState.BIG) {
            setSummaryState(SummaryState.SMALL)
        } else {
            setSummaryState(SummaryState.BIG)
        }
    }, [summaryState, trackInteraction])

    React.useEffect(() => {
        goals.current = getGoals(matchEvents)
        const summary = summaryState === SummaryState.BIG ? matchEvents : goals.current
        setSummary(summary)
    }, [matchEvents, summaryState])

    return (
        <NonFlexingContainer
            position="relative"
            width="100%"
            backgroundColor="pearl"
            testID="liveticker-summary-container-0"
        >
            {summary.length > 0 ? (
                <>
                    <NonFlexingContainer
                        width="100%"
                        backgroundColor="pearl"
                        centerHorizontal
                        zIndex={2}
                        testID={`${testID}-container-1`}
                    >
                        <NonFlexingContainer
                            width={40}
                            backgroundColor={colorPattern.pearl}
                            height={12}
                            testID={`${testID}-container-2`}
                        />
                    </NonFlexingContainer>
                    {summary.map((event, index) => {
                        const key = `summary-event-row-${event.timeLabel}-${index}`
                        return (
                            <SummaryEventRow
                                key={key}
                                {...event}
                                testID={`summary-event-row-${index}`}
                            />
                        )
                    })}
                </>
            ) : null}
            {matchEvents.length > 0 && matchEvents.length !== goals.current.length ? (
                <>
                    <NonFlexingContainer
                        width="100%"
                        backgroundColor="pearl"
                        centerHorizontal
                        zIndex={2}
                        testID={`${testID}-container-3`}
                    >
                        <NonFlexingContainer
                            width={40}
                            backgroundColor={colorPattern.pearl}
                            height={summary.length > 0 ? '16px' : ['16px', '16px', '16px', '24px']}
                            testID={`${testID}-container`}
                        />
                    </NonFlexingContainer>
                    <LivetickerSummaryButton
                        onPress={toggleSummary}
                        buttonType={summaryState === SummaryState.BIG ? 'up' : 'down'}
                    />
                </>
            ) : (
                <NonFlexingContainer
                    width="100%"
                    backgroundColor="pearl"
                    height={['12px', '12px', '16px', '24px']}
                    testID={`${testID}-container-4`}
                />
            )}
        </NonFlexingContainer>
    )
}

export default LivetickerSummary
